export default function formatMinMaxLengthMessage(
  minLength: number,
  maxLength: number,
) {
  return `${minLength}~${maxLength}자 이내 입력 가능`;
}
